import { Grid, Typography } from "@mui/material";
import PrimaryButton from "../../components/custom/PrimaryButton";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components/macro";

const StyledDiv = styled.div`
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-top: 0px;
    padding-right: 0px;
    padding: 10px;
    display: flex;
    justify-content: center;
  }
  padding-top: 90px;
  padding-right: 50px;
  width: 100%;
`;

function VerificationPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const message = searchParams.get("code");

  return (
    <StyledDiv>
      <Grid container spacing={20}>
        <Grid item xs={12} sx={{ marginLeft: [0, 20] }}>
          <Typography variant="h3">REGISTRATION EVALUATION</Typography>
          <Typography variant="body">{message}</Typography>
        </Grid>
        <Grid item xs={12}>
          <PrimaryButton
            sx={{ float: "right" }}
            onClick={() => navigate("/auth/sign-in")}
          >
            BACK TO LOGIN
          </PrimaryButton>
        </Grid>
      </Grid>
    </StyledDiv>
  );
}

export default VerificationPage;
